module.exports = __webpack_public_path__ + "img/shape2.e1ef127f.svg";